export default class AutoReadDataView extends DataView {
    constructor() {
        super(...arguments);
        this.offset = 0;
        this.smallEndian = true;
        this.autoAllocate = true;
        this.allocateSize = 1000;
    }
    getUint8(amount = null) {
        if (amount === null)
            return super.getUint8(this.offset++);
        const rets = [];
        for (let i = 0; i < amount; i++) {
            rets.push(super.getUint8(this.offset));
            this.offset++;
        }
        return rets;
    }
    getUint8UntilNull() {
        const ret = [];
        while (super.getUint8(this.offset) !== 0 && this.offset < this.byteLength) {
            ret.push(this.getUint8());
        }
        if (this.offset < this.byteLength)
            this.offset++;
        return ret;
    }
    pushUint8(...values) {
        for (const i in values) {
            super.setUint8(this.offset, values[i] & 0xff);
            this.offset++;
        }
    }
    pushUint16(...values) {
        for (const i in values) {
            super.setUint16(this.offset, values[i], this.smallEndian);
            this.offset += 2;
        }
    }
    pushInt32(...values) {
        for (const i in values) {
            super.setInt32(this.offset, values[i], this.smallEndian);
            this.offset += 4;
        }
    }
    getUint16(amount = null) {
        if (amount === null) {
            const retValue = super.getUint16(this.offset, this.smallEndian);
            this.offset += 2;
            return retValue;
        }
        const rets = [];
        for (let i = 0; i < amount; i++) {
            rets.push(super.getUint16(this.offset, this.smallEndian));
            this.offset += 2;
        }
        return rets;
    }
    getUint32() {
        const ret = super.getUint32(this.offset, this.smallEndian);
        this.offset += 4;
        return ret;
    }
    getString(amount) {
        let ret = "";
        for (let i = 0; i < amount; i++) {
            ret += String.fromCharCode(super.getUint8(this.offset));
            this.offset += 1;
        }
        return ret;
    }
    getStringUntilNull() {
        let ret = "";
        while (super.getUint8(this.offset) !== 0 && this.offset < this.byteLength) {
            ret += this.getString(1);
        }
        if (this.offset < this.byteLength)
            this.offset++;
        return ret;
    }
    skipBytes(amount) {
        this.offset += amount;
    }
}
//# sourceMappingURL=autoReader.js.map